/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {
        title: "Last 12 hours workload on workstations (within current plan)",
        axis: { x: "Hours", y: "Jobs number", z: "Workstations" },
        compare: {
            compareTitle: "",
            rangeTitle: "Change time range (hours)",
            prev: null,
        }
    },
    currentData: false,
    position: {
        scale: 1,
        rotation: {
            x: 0,
            y: 0,
            z: 0
        },
        clue: {}
    },
    isManipulable: {
        stateName: "centerGraph",
        settings: {
            enabled: { VR: [], desktop: [] },
        },
    },
    isLoading: false,
};

const centerGraphSlice = createSlice({
    name: "centerGraph",
    initialState: initialState,
    reducers: {
        setCenterGraph: (state, action) => {
            Object.assign(state, action.payload)
        },
        updateCenterGraphData: (state, action) => {
            Object.assign(state.data, action.payload)
        },
        setCurrentData: (state, action) => {
            state.currentData = action.payload
        },
        setClue: (state, action) => {
            state.position.clue = action.payload
        },
        setRange: (state, action) => {
            const { from, to } = action.payload
            const xLabels = state.data.xLabels
            const values = state.data.values
            const start = xLabels.indexOf(from)
            const end = xLabels.indexOf(to);

            state.currentData.xLabels = xLabels.slice(start, end + 1)
            if (state.currentData.hasOwnProperty('checked'))
                state.currentData.values = values.filter((e, i) => state.currentData.checked[i])

            state.currentData.values = state.currentData.values.map((value) => value.slice(start, end + 1))

            state.currentData.range = {
                from,
                to,
            }
        },
        setChecked: (state, action) => {
            state.currentData.checked = action.payload
            const { from, to } = state.currentData.range
            const xLabels = state.data.xLabels
            const values = state.data.values
            const start = xLabels.indexOf(from)
            const end = xLabels.indexOf(to);

            state.currentData.zLabels = state.data.zLabels.filter((e, i) => state.currentData.checked[i])
            state.currentData.values = values.filter((e, i) => state.currentData.checked[i])
            state.currentData.values = state.currentData.values.map((value) => value.slice(start, end + 1))
        },
        setRotation: (state, action) => {
            const rotation = action.payload
            state.position.rotation = rotation
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setZoom: (state, action) => {
            const scale = action.payload
            state.position.scale = scale
        },
        resetRotationCenterGraph: (state) => {
            state.position.rotation = initialState.position.rotation
        },
        setComparingData: (state, action) => {
            const { prev, compareTitle } = action.payload
            state.data.compare.compareTitle = compareTitle
            state.data.compare.prev = prev
        },
        setManipulableSettings: (state, action) => {
            Object.assign(
                state.isManipulable.settings.enabled,
                action.payload
            )
        },
        resetInitialGraphState: (state) => {
            Object.assign(state, initialState)
        },
        loadRemoteCenterGraph: (state, action) => {
            Object.assign(state, action.payload)
        },
    }
});

export const {
    resetRotationCenterGraph,
    setManipulableSettings,
    resetInitialGraphState,
    updateCenterGraphData,
    loadRemoteCenterGraph,
    setComparingData,
    setCurrentData,
    setCenterGraph,
    setIsLoading,
    setRotation,
    setChecked,
    setRange,
    setZoom,
    setClue,
} = centerGraphSlice.actions;

export default centerGraphSlice;
